import { NeighborhoodMarketTrendsProps } from "./types";

type OptionalPropertyOf<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? never : K;
  }[keyof T],
  undefined
>;

const defaultState: Pick<
  NeighborhoodMarketTrendsProps["options"],
  OptionalPropertyOf<NeighborhoodMarketTrendsProps["options"]>
> = {
  hideAttribution: false,
};

export const defaultColors = {
  buyerColor: "#21BCCC",
  neutralColor: "#BEBEBE",
  sellerColor: "#FDC033",
  decreaseColor: "#EF4444",
  increaseColor: "#21BCCC",
};

export default defaultState;
